import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import QuizTestReportSearchBox from './components/QuizTestReportSearchBox';
import { getQuizReportTableHeaders } from './helpers/getTableHeaders';
import { getQuizTestReportTableRows } from './helpers/getTableRows';
import useQuizTestReport from './hooks/useQuizTestReport';

const QuizTestReport = () => {
	const hook = useQuizTestReport();

	return (
		<>
			{hook.isLoading && <Loading />}
			<WrapperWithScroll>
				<QuizTestReportSearchBox
					handleSearchCallback={hook.fetchQuizTestReportData}
				></QuizTestReportSearchBox>
				{hook.data && (
					<>
						<Table
							className='styled-table'
							raws={getQuizTestReportTableRows(hook.data)}
							headers={getQuizReportTableHeaders()}
						/>
					</>
				)}
			</WrapperWithScroll>
		</>
	);
};

export default QuizTestReport;
